import { ASSET_APP_IDS } from "@zapier/canvas-constants";

type Params = {
  appId: string;
};

export function shouldShowAppIcon({ appId }: Params) {
  const isTableApp = appId.includes(ASSET_APP_IDS.TABLES);
  const isInterfacesApp = appId.includes(ASSET_APP_IDS.INTERFACES);
  const isChatbotsApp = appId.includes(ASSET_APP_IDS.CHATBOTS);

  if (isTableApp || isInterfacesApp || isChatbotsApp) {
    return false;
  }

  return true;
}
